import { Link } from "react-router-dom";
import { IconNameEnum } from "@b2bportal/core-themes";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import styles from "./BackButton.module.scss";

export type BackButtonProps =
  | {
      as: "button";
      onClick: () => void;
      className?: string;
      label?: string;
    }
  | {
      as: "link";
      to: string;
      className?: string;
      label?: string;
    };

export const BackButton = (props: BackButtonProps) => {
  const { className, label = "back" } = props;

  const content = (
    <>
      <Icon iconName={IconNameEnum.backIcon} />
      <span>{label}</span>
    </>
  );

  if (props.as === "link") {
    return (
      <Link to={props.to} className={clsx(styles.BackButton, className)}>
        {content}
      </Link>
    );
  }

  return (
    <button
      className={clsx(styles.BackButton, className)}
      onClick={props.onClick}
    >
      {content}
    </button>
  );
};
